import { fetch, buildQueryString } from '../utils/request';

const BOARDS_BASE = process.env.BOARDS_API;

/**
 * Get paginated list of tagboards.
 * @param {Number} owner - Owner of the boards.
 * @param {Object} [opts] - Options to filter/paginate results.
 * @returns {Promise<Object>} API Response.
 */
export const getTagboards = (userId, opts = {}) => (
  fetch(`${BOARDS_BASE}/tagboards/${userId}/many${buildQueryString({
    ...opts,
    legacySearch: 'false',
  })}`)
);

export const getTags = (userId) => (
  fetch(`${BOARDS_BASE}/tagboards/${userId}/tags`)
);

/**
 * Get list of tagboards by ID(s).
 * @param {Number} owner - Owner of the boards.
 * @param {Array<Number>} boardIds - List of boards to fetch.
 * @returns {Promise<Object>} API Response.
 */
export const getMultipleTagboards = (userId, boardIds = []) => {
  if (!boardIds.length) {
    return Promise.resolve({
      tagboards: [],
    });
  }

  const query = {
    tagboards: boardIds.join(','),
  };

  return fetch(`${BOARDS_BASE}/tagboards/${userId}/many${buildQueryString(query)}`);
};
